<template>
  <div class="rounded-lg bg-white overflow-x-auto w-full max-w-full border border-slate-300">
    <div class="overflow-x-auto w-full max-w-full">
      <table class="w-full" border="0" cellpadding="0" cellspacing="0">
        <thead class="uppercase">
          <tr v-if="headers" class="divide-x border-b border-slate-300 bg-gray-50">
            <th
              v-for="(header, index) in headers"
              :key="index"
              draggable="true"
              @dragstart="dragStart(index)"
              @dragover.prevent
              @drop="drop(index)"
              class="cursor-move text-nowrap py-1 px-2 text-sm"
              :class="[{ 'min-w-48': header.title === 'Ações' && !header.classes }]"
              :style="header.width ? `width: ${header.width}` : ''">
              <Flex gap-3 items-center :justify-center="header.title === 'Ações'" :class="[header.classes]">
                {{ header.title }}
              </Flex>
            </th>
            <th v-if="expanded" />
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in processedItems" :key="index">
            <tr class="divide-x hover:bg-gray-100" :class="[{ 'border-b border-slate-300': !expanded || !item.expanded }, computedClass(item)]">
              <!-- @click.right.prevent="sendRightClick(item)" -->
              <td
                v-for="header in headers"
                :key="header"
                class="py-1 px-2 text-sm"
                :class="[header.align, { 'text-nowrap': noWrap }]"
                :style="header.width ? `width: ${header.width}` : ''">
                <div v-if="item" class="h-full" :class="[header.title === 'Ações' ? 'flex justify-center' : '']">
                  <slot :name="header.field" :item="item" :rowIndex="index">{{ item[header.field] }}</slot>
                </div>
                <div v-else-if="!item[header.field]" class="h-full" :class="[header.title === 'Ações' ? 'flex justify-center' : '']">
                  <slot :name="header.field" :item="item" :rowIndex="index">{{ item[header.fallback] }}</slot>
                  <div v-if="!item[header.fallback]">
                    <slot :name="header.field" :item="item" :rowIndex="index">{{ header.error }}</slot>
                  </div>
                </div>
              </td>

              <td v-if="expanded" class="w-8">
                <Flex center>
                  <i class="fa-solid cursor-pointer" :class="[{ 'fa-sort-up': !item.expanded, 'fa-sort-down': item.expanded }]" @click="item.expanded = !item.expanded"></i>
                </Flex>
              </td>
            </tr>

            <tr v-if="expanded && item.expanded">
              <td :colspan="headers?.length + 1">
                <slot name="expanded" :item="item"></slot>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <p class="text-center italic py-1 border-y border-slate-300" v-if="items && items?.length < 1">Nenhum item a ser exibido.</p>
    <div class="py-1 text-sm" v-if="!disablePagination">
      <SimpleTableNav v-if="items?.length" v-model="currentPage" v-model:max="maxItems" :totalItems="items.length" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'

const emit = defineEmits(['selectedItem', 'update:modelValue', 'order', 'rightClick'])
const props = defineProps({
  headers: {
    type: Array,
    default: [],
    required: true,
  },
  items: Array,
  disablePagination: Boolean,
  total: Boolean,
  itemsPerPage: {
    type: Number,
    default: 20,
  },
  modelValue: {
    type: Number,
    default: 1,
  },
  totalItems: Number,
  totalPages: Number,
  expanded: Boolean,
  noWrap: Boolean,
})

const currentPage = ref(1)
const maxItems = ref(props.itemsPerPage)
const dragIndex = ref(null)

const dragStart = (index) => {
  dragIndex.value = index
}

const drop = (dropIndex) => {
  if (dragIndex.value === null || dragIndex.value === dropIndex) return

  const draggedHeader = props.headers[dragIndex.value]
  props.headers.splice(dragIndex.value, 1)
  props.headers.splice(dropIndex, 0, draggedHeader)
  dragIndex.value = null
}

const computedClass = (item) => {
  return item.class
}

const processedItems = computed(() => {
  const pag = (currentPage.value - 1) * maxItems.value
  const maxData = currentPage.value * maxItems.value
  const limit = maxData < props.items.length ? maxData : props.items.length
  return props.items.slice(pag, limit)
})

watch(
  () => props.modelValue,
  (newVal) => {
    currentPage.value = newVal
  }
)

watch(currentPage, (page) => {
  emit('update:modelValue', page)
})

// watch(
//   () => props.headers,
//   (newHeaders, oldHeaders) => {
//     if (newHeaders && oldHeaders) {
//       const oldHeadersMap = oldHeaders.reduce((acc, header) => {
//         acc[header.field] = header.orderState
//         return acc
//       }, {})

//       const sumHeadersMap = props.sumHeaders.reduce((acc, sumHeader) => {
//         acc[sumHeader.field] = sumHeader.format || null
//         return acc
//       }, {})

//       newHeaders.forEach((header) => {
//         const key = header.field
//         header.orderState = oldHeadersMap[key] !== undefined ? oldHeadersMap[key] : 1

//         if (sumHeadersMap[key]) {
//           header.format = sumHeadersMap[key]
//         }
//       })
//     }
//   },
//   { deep: true }
// )

onMounted(() => {
  if (props.headers) {
    props.headers.forEach((header) => (header.orderState = 1))
  }
  currentPage.value = props.modelValue
})
</script>
